import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ReactPlayer from "react-player";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../App";
import Calender from "../../../assets/images/calendar.png";
import cup from "../../../assets/images/page 1.png";
import "./PostContentMaking.css";
import useFileHandleS3 from "../../../CustomHooks/useFileHandleS3";
import useVdieoHandleS3 from "../../../CustomHooks/useVideoHandleS3";
import MediaUploadProgressBar from "../../../Screen/MediaUploadProgressBar";
import useVideoHandleWithCompress from "../../../CustomHooks/useVideoHandleWithCompress";

const RoundInstructionCreate = () => {
  const { imageCdnUrl, videoCdnUrl } = useContext(serverInfo);

  const history = useHistory();
  const { slug } = useParams();
  const [event, setEvent] = useState({});


  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState([]);
  const [rounds, setRounds] = useState([]);
  const [auditionId, setAuditionId] = useState("");
  const [videoDuration, setVideoDuration] = useState("");
  const [videoSlot, setVideoSlot] = useState("");
  const [appealVideoDuration, setAppealVideoDuration] = useState("");
  const [appealVideoSlot, setAppealVideoSlot] = useState("");
  const [appeal_fee, setAppealFee] = useState();
  const [roundId, setRoundId] = useState("");
  const [activeRound, setActiveRound] = React.useState({});
  const [fileVideo, setFileVideo] = useState("");
  const [preDocFile, setPreDocFile] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [videoFile, setVideoFile] = useState("");

  const [convertedContent, setConvertedContent] = useState();
  const [errorList, setErrorList] = useState([]);

  // File Handle
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl, fileKey, progress] = useFileHandleS3(file, 'audition/images', delKey);

  // Video File Handle
  const [video, setVideo] = useState('');
  const [videoDelKey, setVideoDelKey] = useState(null);
  const [videoUrl, videoKey, videoProgress, videoHeight,videoWidth] = useVideoHandleWithCompress(video, 'audition/videos', videoDelKey);

  // Document File Handle
  const [docFile, setDocFile] = useState('');
  const [docFileDelKey, setDocFileDelKey] = useState(null);
  const [docFileUrl, docFileKey, docFileProgress] = useVideoHandleWithCompress(docFile, 'audition/documents', docFileDelKey);


  const submitRoundInstruction = (e) => {
    e.preventDefault();
    setLoading(true);
    const fData = new FormData();
    fData.append("audition_id", auditionId);
    fData.append("round_info_id", roundId);
    fData.append("round_instruction_id", activeRound?.round_instruction?.id);
    fData.append("instruction", convertedContent);
    fData.append("video", videoKey ? videoKey : videoFile);
    fData.append("image", fileKey ? fileKey : imageFile);
    fData.append("pdf", docFileKey ? docFileKey : preDocFile);
    fData.append("video_time_duration", videoDuration);
    fData.append("video_slot", videoSlot);
    fData.append("appeal_video_time_duration", appealVideoDuration);
    fData.append("appeal_video_slot_num", appealVideoSlot);
    fData.append("appeal_fee", appeal_fee);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/audition-admin/audition/round-instruction/store`, fData)
        .then((res) => {
          setLoading(false);
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");

            fetchAuditions();
            // history.goBack();
          } else {
            setErrorList(res.data.validation_errors);
          }
        });
    });
  };

  const handleImageChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };
  const handleVideoChange = (file) => {
    setVideoDelKey(videoKey);
    setVideo(file[0]);
  };

  const handlePdfChange = (file) => {
    setDocFileDelKey(docFileDelKey)
    setDocFile(file[0]);
  };

  const handleChange = (event) => {
    setAuditionId(event.target.value);
  };
  const handleVideoDuration = (event) => {
    setVideoDuration(event.target.value);
  };
  const handleVideoSlot = (event) => {
    setVideoSlot(event.target.value);
  };
  const handleAppealVideoDuration = (event) => {
    setAppealVideoDuration(event.target.value);
  };
  const handleAppealVideoSlot = (event) => {
    setAppealVideoSlot(event.target.value);
  };

  const handleRoundChange = (event) => {
    setRoundId(event.target.value);
  };

  const fetchAuditions = () => {
    axios.get(`/api/audition-admin/audition/events`).then((res) => {
      setLoading(false);
      if (res.data.status === 200) {
        setEvents(res.data.events);
        // setLoading(false);

      }
    });
  };

  useEffect(() => {
    fetchAuditions();
  }, []);

  useEffect(() => {
    setLoading(true);
    var result = events.find((item) => item.id == auditionId);
    setEvent(result);

    setRounds(result?.audition_round);
    setLoading(false);
  }, [auditionId]);

  useEffect(() => {
    setLoading(true);
    var result = rounds.find((item) => item.id == roundId);
    setActiveRound(result);

    if (result?.round_instruction?.instruction != null) {
      setConvertedContent(result?.round_instruction?.instruction);
    } else {
      setConvertedContent("");
    }

    if (result?.round_instruction?.video != null) {
      setVideoFile(result?.round_instruction?.video);
    } else {
      setVideoFile("");
    }

    if (result?.round_instruction?.image != null) {
      setImageFile(result?.round_instruction?.image);
    } else {
      setImageFile("");
    }
    if (result?.round_instruction?.document != null) {
      setPreDocFile(result?.round_instruction?.document);
    } else {
      setPreDocFile("");
    }

    if (result?.video_duration != null) {
      setVideoDuration(result?.video_duration);
    } else {
      setVideoDuration("");
    }

    if (result?.video_slot_num != null) {
      setVideoSlot(result?.video_slot_num);
    } else {
      setVideoSlot("");
    }

    if (result?.appeal_video_duration != null) {
      setAppealVideoDuration(result?.appeal_video_duration);
    } else {
      setAppealVideoDuration("");
    }

    if (result?.appeal_video_slot_num != null) {
      setAppealVideoSlot(result?.appeal_video_slot_num);
    } else {
      setAppealVideoSlot("");
    }
    if (result?.appeal_fee != null) {
      setAppealFee(result?.appeal_fee);
    } else {
      setAppealFee("");
    }

    setLoading(false);
  }, [roundId]);

  return (
    <>
      <div className="card card-bg head-line mb-2 mb-2">
        <div className="text-light d-flex justify-content-center p-2">
          <div className="faTrophy">
            <img src={cup} alt="" width="30px" />
          </div>
          <h4 className="mx-3 text-white p-2">
            Edit Round Instruction for Star
          </h4>
        </div>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form
                  onSubmit={submitRoundInstruction}
                  id="input_form"
                  encType="multipart/form-data"
                >
                  <div className="row">
                    <div className="form-group row mt-3">
                      <label
                        for="staticEmail"
                        className="col-sm-3 label-text fw-bold"
                      >
                        Select An Audition
                      </label>
                      <div className="col-sm-9">
                        <select
                          onChange={handleChange}
                          className="form-select form-control reply-control text-black"
                          aria-label="Default select example"
                          id="audition_id"
                          name="audition_id"
                        >
                          <option value="0">--Select Audition--</option>
                          {events.map((event, index) => (
                            <option key={index} value={event?.id}>
                              {event?.title}
                            </option>
                          ))}
                        </select>
                        <span className="text-danger">
                          {errorList.audition_id}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row mt-3">
                      <label
                        for="staticEmail"
                        className="col-sm-3 label-text fw-bold"
                      >
                        Select A Round
                      </label>
                      <div className="col-sm-9">
                        <select
                          onChange={handleRoundChange}
                          className="form-select form-control reply-control text-black"
                          aria-label="Default select example"
                          id="audition_id"
                          name="audition_id"
                        >
                          <option value="0">--Select Round--</option>
                          {rounds &&
                            rounds.length > 0 &&
                            rounds.map((round, index) => (
                              <option key={index} value={round?.id}>
                                Round - {round?.round_num}
                              </option>
                            ))}
                        </select>
                        <span className="text-danger">
                          {errorList.audition_id}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row mt-3">
                      <label
                        for="inputPassword"
                        className="col-sm-3 label-text fw-bold"
                      >
                        Instruction
                      </label>
                      <div className="col-sm-9">
                        <CKEditor
                          editor={ClassicEditor}
                          data={convertedContent}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setConvertedContent(data);
                          }}
                        />
                        <span className="text-danger">
                          {errorList.instruction}
                        </span>
                      </div>
                    </div>

                    <div className="form-group row mt-3">
                      <label
                        for="inputPassword"
                        className="col-sm-3 label-text fw-bold"
                      >
                        Upload Video
                      </label>
                      <div className="col-sm-9">
                        {videoUrl ? (
                          <>
                            <ReactPlayer
                              url={videoUrl}
                              controls
                              playing={false}
                              volume={1}
                              width="300px"
                              style={{ maxHeight: "200px" }}
                            />
                          </>
                        ) : (
                          videoFile ? <>
                            <ReactPlayer
                              url={videoCdnUrl + videoFile}
                              controls
                              playing={false}
                              volume={1}
                              width="300px"
                              style={{ maxHeight: "200px" }}
                            /></> : ""
                        )}
                        <input
                          type="file"
                          name="videoFile"
                          className="form-control reply-control"
                          accept="video/*"
                          onChange={(e) => handleVideoChange(e.target.files)}
                        />
                        {video && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}
                        <label for="setFile">
                          <i className="fas fa-cloud-upload-alt"></i> Upload
                          Video
                        </label>
                        <span className="text-danger">{errorList.video}</span>
                      </div>
                    </div>

                    <div className="form-group row mt-3">
                      <label
                        for="inputPassword"
                        className="col-sm-3 label-text fw-bold "
                      >
                        Upload Banner
                      </label>
                      <div className="col-sm-9">
                        {fileUrl ? (
                          <img
                            src={fileUrl}
                            alt="..."
                            className="demo-preview-image img-fluid"
                            style={{ maxHeight: "200px", width: "300px" }}
                          />
                        ) : (
                          imageFile ? <img
                            src={imageCdnUrl + imageFile}
                            alt="..."
                            className="demo-preview-image img-fluid"
                            style={{ maxHeight: "200px", width: "300px" }}
                          /> : ""
                        )}
                        <input
                          type="file"
                          name="imageFile"
                          className="form-control reply-control"
                          accept="image/*"
                          onChange={(e) => handleImageChange(e.target.files)}
                        />
                        {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}

                        <span className="text-danger">{errorList.image}</span>
                      </div>
                    </div>

                    <div className="form-group row mt-3">
                      <label
                        for="inputPassword"
                        className="col-sm-3 label-text fw-bold"
                      >
                        Instruction PDF
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="file"
                          name="pdffile"
                          className="form-control reply-control"
                          accept=".pdf"
                          onChange={(e) => handlePdfChange(e.target.files)}
                        />
                        {docFile && !docFileUrl && <MediaUploadProgressBar progress={docFileProgress} />}

                      </div>
                    </div>

                    <div className="row mt-3">
                      {activeRound?.round_type === 0 ? (
                        <>
                          <label
                            for="staticEmail"
                            className="col-md-3 mb-3 label-text fw-bold"
                          >
                            Video Time Duration (S)
                          </label>

                          <div className="col-md-3 mb-3">
                            <input
                              type="number"
                              className="form-control reply-control text-black"
                              onChange={handleVideoDuration}
                              value={videoDuration}
                            />

                            <span className="text-danger">
                              {errorList.video_time_duration}
                            </span>
                          </div>

                          <label
                            for="staticEmail"
                            className="col-md-3 mb-3 label-text fw-bold text-md-end"
                          >
                            Video Slot
                          </label>
                          <div className="col-md-3 mb-3">
                            <input
                              type="number"
                              className="form-control reply-control text-black"
                              onChange={handleVideoSlot}
                              value={videoSlot}
                            />
                            <span className="text-danger">
                              {errorList.video_slot}
                            </span>
                          </div>

                          {activeRound?.appeal === 1 ? (
                            <>
                              <label
                                for="staticEmail"
                                className="col-md-3 label-text fw-bold"
                              >
                                Appeal Video Time Duration
                              </label>
                              <div className="col-md-3">
                                <input
                                  type="number"
                                  className="form-control reply-control text-black"
                                  onChange={handleAppealVideoDuration}
                                  value={appealVideoDuration}
                                />

                                <span className="text-danger">
                                  {errorList.appeal_video_time_duration}
                                </span>
                              </div>

                              <label
                                for="staticEmail"
                                className="col-md-3 label-text fw-bold text-md-end"
                              >
                                Appeal Video Slot
                              </label>
                              <div className="col-md-3">
                                <input
                                  type="number"
                                  className="form-control reply-control text-black"
                                  onChange={handleAppealVideoSlot}
                                  value={appealVideoSlot}
                                />

                                <span className="text-danger">
                                  {errorList.appeal_video_slot}
                                </span>
                              </div>

                              <div className="form-group row mt-4">
                                <label
                                  for="staticEmail"
                                  className="col-sm-3 label-text fw-bold"
                                >
                                  Appeal Fees
                                </label>
                                <div className="col-sm-9">
                                  <input
                                    type="number"
                                    className="form-control reply-control"
                                    placeholder="Enter Appeal Fees..!"
                                    onChange={(e) =>
                                      setAppealFee(e.target.value)
                                    }
                                    name="appeal_fee"
                                    value={appeal_fee}
                                  />
                                  <span className="text-danger">
                                    {errorList.appeal_fee}
                                  </span>
                                </div>
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>

                  <div className="row mt-4 mb-3">
                    <div className="row justify-content-center">
                      <div className="col-md-5 mb-3">
                        <div className="card card-bg-p px-3 py-2">
                          <div className="d-flex">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">Start Date</small>
                              <h5 className="text-warning fw-bold">
                                {activeRound?.round_start_date ??
                                  moment(activeRound?.round_start_date).format(
                                    "LL"
                                  )}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-5 mb-3">
                        <div className="card card-bg-p px-3 py-2">
                          <div className="d-flex">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">End Date</small>
                              <h5 className="text-warning fw-bold">
                                {activeRound?.round_end_date ??
                                  moment(activeRound?.round_end_date).format(
                                    "LL"
                                  )}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      {activeRound?.round_type == 0 ? (
                        <>
                          <div className="col-md-5 mb-3">
                            <div className="card card-bg-p px-3 py-2">
                              <div className="d-flex">
                                <div>
                                  <img src={Calender} alt="" className="p-2" />
                                </div>
                                <div>
                                  <small className="text-light">
                                    Video Upload Start Date
                                  </small>
                                  <h5 className="text-warning fw-bold">
                                    {activeRound?.video_upload_start_date ??
                                      moment(
                                        activeRound?.video_upload_start_date
                                      ).format("LL")}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-5 mb-3">
                            <div className="card card-bg-p px-3 py-2">
                              <div className="d-flex">
                                <div>
                                  <img src={Calender} alt="" className="p-2" />
                                </div>
                                <div>
                                  <small className="text-light">
                                    Video Upload End Date
                                  </small>
                                  <h5 className="text-warning fw-bold">
                                    {activeRound?.video_upload_end_date ??
                                      moment(
                                        activeRound?.video_upload_end_date
                                      ).format("LL")}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}

                      <div className="col-md-5 mb-3">
                        <div className="card card-bg-p px-3 py-2">
                          <div className="d-flex">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">
                                Marking Start Date
                              </small>
                              <h5 className="text-warning fw-bold">
                                {activeRound?.jury_or_judge_mark_start_date ??
                                  moment(
                                    activeRound?.jury_or_judge_mark_start_date
                                  ).format("LL")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-5 mb-3">
                        <div className="card card-bg-p px-3 py-2">
                          <div className="d-flex">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">
                                Marking End Date
                              </small>
                              <h5 className="text-warning fw-bold">
                                {activeRound?.jury_or_judge_mark_end_date ??
                                  moment(
                                    activeRound?.jury_or_judge_mark_end_date
                                  ).format("LL")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-5 mb-3">
                        <div className="card card-bg-p px-3 py-2">
                          <div className="d-flex">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">
                                Result Publish Start Date
                              </small>
                              <h5 className="text-warning fw-bold">
                                {activeRound?.result_publish_start_date ??
                                  moment(
                                    activeRound?.result_publish_start_date
                                  ).format("LL")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-5 mb-3">
                        <div className="card card-bg-p px-3 py-2">
                          <div className="d-flex">
                            <div>
                              <img src={Calender} alt="" className="p-2" />
                            </div>
                            <div>
                              <small className="text-light">
                                Result Publish End Date
                              </small>
                              <h5 className="text-warning fw-bold">
                                {activeRound?.result_publish_end_date ??
                                  moment(
                                    activeRound?.result_publish_end_date
                                  ).format("LL")}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      {activeRound?.round_type == 0 ? (
                        <>
                          <div className="col-md-5 mb-3">
                            <div className="card card-bg-p px-3 py-2">
                              <div className="d-flex">
                                <div>
                                  <img src={Calender} alt="" className="p-2" />
                                </div>
                                <div>
                                  <small className="text-light">
                                    Appeal Start Date
                                  </small>
                                  <h5 className="text-warning fw-bold">
                                    {activeRound?.appeal_start_date ??
                                      moment(
                                        activeRound?.appeal_start_date
                                      ).format("LL")}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-5 mb-3">
                            <div className="card card-bg-p px-3 py-2">
                              <div className="d-flex">
                                <div>
                                  <img src={Calender} alt="" className="p-2" />
                                </div>
                                <div>
                                  <small className="text-light">
                                    Appeal End Date
                                  </small>
                                  <h5 className="text-warning fw-bold">
                                    {activeRound?.appeal_end_date ??
                                      moment(
                                        activeRound?.appeal_end_date
                                      ).format("LL")}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-5 mb-3">
                            <div className="card card-bg-p px-3 py-2">
                              <div className="d-flex">
                                <div>
                                  <img src={Calender} alt="" className="p-2" />
                                </div>
                                <div>
                                  <small className="text-light">
                                    Appeal Video Upload Start Date
                                  </small>
                                  <h5 className="text-warning fw-bold">
                                    {activeRound?.appeal_video_upload_start_date ??
                                      moment(
                                        activeRound?.appeal_video_upload_start_date
                                      ).format("LL")}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-5 mb-3">
                            <div className="card card-bg-p px-3 py-2">
                              <div className="d-flex">
                                <div>
                                  <img src={Calender} alt="" className="p-2" />
                                </div>
                                <div>
                                  <small className="text-light">
                                    Appeal Video Upload End Date
                                  </small>
                                  <h5 className="text-warning fw-bold">
                                    {activeRound?.appeal_video_upload_end_date ??
                                      moment(
                                        activeRound?.appeal_video_upload_end_date
                                      ).format("LL")}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-5 mb-3">
                            <div className="card card-bg-p px-3 py-2">
                              <div className="d-flex">
                                <div>
                                  <img src={Calender} alt="" className="p-2" />
                                </div>
                                <div>
                                  <small className="text-light">
                                    Appeal Marking Start Date
                                  </small>
                                  <h5 className="text-warning fw-bold">
                                    {activeRound?.appeal_jury_or_judge_mark_start_date ??
                                      moment(
                                        activeRound?.appeal_jury_or_judge_mark_start_date
                                      ).format("LL")}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-5 mb-3">
                            <div className="card card-bg-p px-3 py-2">
                              <div className="d-flex">
                                <div>
                                  <img src={Calender} alt="" className="p-2" />
                                </div>
                                <div>
                                  <small className="text-light">
                                    Appeal Marking End Date
                                  </small>
                                  <h5 className="text-warning fw-bold">
                                    {activeRound?.appeal_jury_or_judge_mark_end_date ??
                                      moment(
                                        activeRound?.appeal_jury_or_judge_mark_end_date
                                      ).format("LL")}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-5 mb-3">
                            <div className="card card-bg-p px-3 py-2">
                              <div className="d-flex">
                                <div>
                                  <img src={Calender} alt="" className="p-2" />
                                </div>
                                <div>
                                  <small className="text-light">
                                    Appeal Result Publish Start Date
                                  </small>
                                  <h5 className="text-warning fw-bold">
                                    {activeRound?.appeal_result_publish_start_date ??
                                      moment(
                                        activeRound?.appeal_result_publish_start_date
                                      ).format("LL")}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-5 mb-3">
                            <div className="card card-bg-p px-3 py-2">
                              <div className="d-flex">
                                <div>
                                  <img src={Calender} alt="" className="p-2" />
                                </div>
                                <div>
                                  <small className="text-light">
                                    Appeal Result Publish End Date
                                  </small>
                                  <h5 className="text-warning fw-bold">
                                    {activeRound?.appeal_result_publish_end_date ??
                                      moment(
                                        activeRound?.appeal_result_publish_end_date
                                      ).format("LL")}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>

                  {/* Create Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-12 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnCreate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnCreate fw-bold" type="submit">
                          Confirm
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Create Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoundInstructionCreate;
